<template>
  <keep-alive>
    <component v-bind:is="pipelineComponent"></component>
  </keep-alive>
</template>

<script>
import PipelinePageDesktop from "./PipelinePageDesktop";
import PipelinePageMobile from "./PipelinePageMobile";

export default {
  name: "PipelinePage",
  metaInfo: {
    title: "Pipeline"
  },
  components: {
    PipelinePageDesktop,
    PipelinePageMobile,
  },
  computed: {
    pipelineComponent() {
      if (this.$store.state.isMobile) {
        return "PipelinePageMobile";
      }

      return "PipelinePageDesktop";
    }
  },
  beforeRouteEnter(to, from, next) {
    // if modal is already open then continue
    if (String(to.query["modal"]) === "welcome") return next();

    // if coming from set up page then open welcome modal
    if (from.name === 'account-setup' || from.name === 'accept-invite') {
      next({name: "pipeline", params: {tab: "active"}, query: {modal: "welcome"}});
    }

    next()
  },
};
</script>
